export default __webpack_public_path__ + "static/media/prints_back.fd67bcdc.jpeg";